import { useCurrentOrg } from '~/features/orgnisations/hooks/useCurrentOrg'

const useIsOrgId = (targetOrgID: string) => {
  const { id: currentOrgID } = useCurrentOrg()
  return currentOrgID === targetOrgID
}

export const useIsDomusvie = () => useIsOrgId('b54329a9-fe86-4117-b3ef-d962eadb9c8c')

export const useIsEiffage = () => useIsOrgId('05cc534c-4b0a-42c4-8b39-451a6c72d010')
